import { Box } from "@mui/material";
import React from "react";
import Header from "src/Component/content-component/Header";
import ParaData from "src/Component/content-component/ParaData";
import ContentContainer from "src/Component/grid-component/ContentContainer";
import ImageContainer from "src/Component/grid-component/ImageContainer";
import MainContainer from "src/Component/grid-component/MainContainer";

const ImmersionProgramme = () => {
  const imageBaseUrl = process.env.REACT_APP_IMAGE_URL;
  const ImmigrationImg1 = imageBaseUrl +"International-Relation/IndiaPage/globalImmersion.png";
  return (
    <Box id="global-immersion">
      <MainContainer
        com1={
          <ContentContainer
            Header={
              <Header content={"Global Immersion Programme"} color="#00999E" />
            }
            Content={
              <ParaData
                color={"#525560"}
                fontSize={"16px"}
                content={
                  <>
                    Taksheela facilitates Global Immersion, which is a unique
                    opportunity for students to dive into the real world of
                    international business markets by visiting your choice of
                    one of the below-mentioned destinations. Available for our
                    students and faculty members at HEIs, we design Global
                    Immersion that allows them to have the opportunity to expand
                    their network and exposure with other students/faculty
                    members across the globe, by attending masterclasses,
                    company visits, local and global executive meetings, all
                    while exploring the new culture.{" "}
                    <a
                      href="/immersion"
                      style={{
                        textDecoration: "none",
                        color: "#00999E",
                        fontWeight: "bold",
                      }}
                    >
                      Read more
                    </a>
                  </>
                }
              />
            }
          />
        }
        com2={<ImageContainer img={ImmigrationImg1} />}
      />
    </Box>
  );
};

export default ImmersionProgramme;
